<template lang="html">
  <div id="report-summary">
    <div class="summary-wrap">
      <div class="grid-container summary-container">
        <div class="row report-summary-grid no-gutters">
          <div class="col row no-gutters align-items-center remix-logo-wrap">
            <img
              src="../../assets/remix_logo_orange.svg"
              alt="Marketing Remix"
              class="bypassme remix-logo"
            />

            <div class="sum-tri-wrap left">
              <div class="tri"></div>
            </div>
          </div>

          <div
            class="col col-sm-auto row no-gutters justify-content-center align-items-center score-wrap"
          >
            <div class="text-center score-box">
              <h1 class="main-score">{{ fullPercent }}%</h1>
              <h2 class="total-score">Total Score</h2>
            </div>
          </div>

          <div
            class="col row no-gutters justify-content-end align-items-center wmk-logo-wrap"
          >
            <div class="sum-tri-wrap right">
              <div class="tri"></div>
            </div>

            <img
              src="../../assets/wmk.svg"
              alt="Marketing Remix"
              class="bypassme wmk-logo"
            />
          </div>
        </div>

        <div class="summary-block-wrap">
          <div class="row align-items-end summary-block">
            <results-group-summary
              v-for="(g, i) in groups"
              :key="'g' + i"
              :group="g"
              :index="i"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GroupSummary from "@/views/Results/GroupSummary";

export default {
  components: {
    "results-group-summary": GroupSummary,
  },
  props: ["groups"],
  data() {
    return {
      form: this.$store.state.formData,
      content: this.$store.state.content,
      docDefinition: this.$store.state.docDefinition,
    };
  },
  computed: {
    fullScore() {
      let scores = [];
      let con = this.content;
      for (let v in con) {
        let type = con[v].form.type;
        let opt = con[v].form.options;
        if (type === "checkbox" || type === "checkbox2") {
          opt.forEach((x) => {
            let score = x.score ? x.score : 0;
            scores.push(score);
          });
        } else {
          let groupScore = [];
          opt.forEach((x) => {
            let score = x.score ? x.score : 0;
            groupScore.push(score);
          });
          scores.push(Math.max.apply(null, groupScore));
        }
      }
      return scores.length
        ? scores.reduce((a, v) => {
            return a + v;
          })
        : 0;
    },
    userScore() {
      let scores = [];
      let form = this.form;
      for (let v in form) {
        let score = form[v].score ? form[v].score : 0;
        scores.push(score);
      }
      return scores.length
        ? scores.reduce((a, v) => {
            return a + v;
          })
        : 0;
    },
    fullPercent() {
      return Math.round((this.userScore / this.fullScore) * 100);
    },
  },
  created() {
    // const wmkLogo = {
    //   image: "/assets/wmk.png",
    //   link: "https://wmkagency.com",
    //   width: 150,
    //   style: "wmkLogo",
    // };

    const title = {
      text: "MARKETING REMIX",
      style: "topHeader",
    };

    const score = {
      text: this.fullPercent + "%",
      style: "headerScore",
    };

    this.docDefinition.content.push(
      //wmkLogo,
      title,
      score
    );
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vars";
@import "../../assets/scss/mixins";

#report-summary {
  color: white;
  padding-bottom: gu(2);

  @media only screen and (min-width: 40rem) {
    padding-bottom: gu(4);
  }
}

.summary-container {
  max-width: 80rem;
}

.report-summary-grid {
  margin-bottom: gu(2);

  @media only screen and (min-width: 40rem) {
    margin-bottom: gu(4);
  }

  & > * {
    height: rem-calc(135);
  }
}

$edge-width: calc(calc(100vw - #{$global-width}) / 2);

.remix-logo-wrap {
  position: relative;
  background-color: $white;
  margin-right: rem-calc(68);

  &::before {
    position: absolute;
    content: "";
    background-color: $white;
    top: 0;
    height: 100%;
    right: 100%;
    width: gu(6);

    @media only screen and (min-width: #{$global-width}) {
      width: calc(#{$edge-width} + #{gu(6)});
    }
  }
}

.remix-logo {
  width: auto;
  height: rem-calc(65);

  @media only screen and (min-width: #{rem-calc(1100)}) {
    height: rem-calc(93);
  }
}

.sum-tri-wrap {
  position: absolute;
  height: 50.74%;

  .tri {
    position: relative;
    height: 100%;
    width: rem-calc(135);

    &::after {
      position: absolute;
      content: "";
      background-color: $white;
      height: calc(100% + #{rem-calc(2)});
      width: 100%;
    }
  }

  &.left {
    right: 0;
    bottom: 0;

    .tri {
      &::after {
        right: rem-calc(2);
        transform-origin: right bottom;
        transform: rotate(90deg);
        bottom: 0;
        clip-path: polygon(
          0% 100%,
          0% calc(100% - #{rem-calc(2)}),
          100% 0%,
          100% 100%
        );
      }
    }
  }

  &.right {
    left: 0;
    top: 0;

    .tri::after {
      top: 0;
      left: rem-calc(2);
      transform-origin: left top;
      transform: rotate(90deg);
      clip-path: polygon(0% 0%, 100% 0%, 100% #{rem-calc(2)}, 0% 100%);
    }
  }
}

.score-box {
  padding: 0 gu(2.5);
}

.main-score {
  font-size: rem-calc(90);
  font-weight: $fwBold;
  line-height: 1;
  margin-bottom: 0;
}

.total-score {
  font-size: rem-calc(25);
  font-weight: $fwBold;
  line-height: 1;
  margin-bottom: 0;
  text-transform: uppercase;
}

.wmk-logo-wrap {
  position: relative;
  background-color: $white;
  margin-left: rem-calc(68);

  &::after {
    position: absolute;
    content: "";
    background-color: $white;
    top: 0;
    height: 100%;
    left: 100%;
    width: gu(6);

    @media only screen and (min-width: #{$global-width}) {
      width: calc(#{$edge-width} + #{gu(6)});
    }
  }
}

.wmk-logo {
  height: rem-calc(55);

  @media only screen and (min-width: #{rem-calc(1100)}) {
    height: rem-calc(93);
  }
}
</style>
